import { useState } from "react";
import { forceLogoutOn401 } from "../../utils/function";

const baseURL =
  window.location.hostname.includes("dev.")
    ? "https://dev.api.vouchlinks.com/api/v1"
    : "https://api.vouchlinks.com/api/v1";
   //"https://dev.api.vouchlinks.com/api/v1"

export default function useRequest(
  endpoint: string,
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
  headers?: Record<string, any>
) {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<any>();
  const [statusCode, setStatusCode] = useState(0);
  const token = localStorage.getItem("token");

  async function makeRequest(
    data?: any,
    params?: Record<string, any>,
    pathParam?: string
  ) {
    setLoading(true);

    const queryParams = new URLSearchParams(params || {}).toString();
    const urlWithParams =
      pathParam && queryParams
        ? `${baseURL}${endpoint}/${pathParam}?${queryParams}`
        : pathParam
          ? `${baseURL}${endpoint}/${pathParam}`
          : queryParams
            ? `${baseURL}${endpoint}?${queryParams}`
            : `${baseURL}${endpoint}`;

    try {
      const res = await fetch(urlWithParams, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          ...headers,
        },
        body:
          ["POST", "PUT", "DELETE", "PATCH"].includes(method) && data
            ? JSON.stringify(data)
            : undefined,
      });

      const json = await res.json();

      setResponse(json);
      setStatusCode(res.status);

      if (res.status === 401) {
        // Token missing/invalid/expired (including a second tab's fresh login silently
        // invalidating this tab's copy) — force an actual logout instead of leaving every
        // subsequent request on this page failing with no way to recover.
        forceLogoutOn401();
        return [null, json];
      }

      if (!res.ok) {
        return [null, json];
      }

      return [json, null];
    } catch (error: any) {
      const errorMessage =
        error?.message === "Failed to fetch"
          ? "Network error, please check your connection."
          : "An error occurred, please try again";

      return [null, { message: errorMessage }];
    } finally {
      setLoading(false);
    }
  }

  return { loading, makeRequest, response, statusCode };
}
